import React, { useEffect, useState } from "react";
import './HowToPlayView.style.scss';
import { FormattedMessage } from "react-intl";
import { useNavigate } from "react-router-dom";
import PayoutDistributionTable from "../../components/PayoutDistributionTable/PayoutDistributionTable";
import Pick12PayoutCalculator from "../../services/Pick12ParlayPayoutCalculator";
import Pick16PayoutCalculator from "../../services/Pick16ParlayPayoutCalculator";
import GlobalConst from "../../constants/GlobalConst";

const HowToPlayView = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const mainContentDiv = document.querySelector('.mainContent');
        if (mainContentDiv) {
            mainContentDiv.style.marginRight = '0';
            mainContentDiv.style.marginLeft = '0';
        }
        return () => {
            if (mainContentDiv) {
                mainContentDiv.style.marginRight = '10px';
                mainContentDiv.style.marginLeft = '10px';
            }
        };
    }, []);

    return (
        <div className="HowToPlayView">
            <div className="tradefanNewestGames">
                <div className="tradefanNewestGamesContent">
                    <div className="mainTitle gold-gradient-text">
                        <FormattedMessage id="help.howToPlay.tradefanNewestGames.title" values={{ x: (chunks) => <i>{chunks}</i> }}/>
                    </div>
                    <p><FormattedMessage id="help.howToPlay.tradefanNewestGames.subtitle" /></p>
                    <div className="tradefanNewestGameImage" />
                </div>
            </div>
            <div className="whatIsPickX">
                <div className="whatIsPickXContent">
                    <div className="mainTitle gold-gradient-text">
                        <FormattedMessage id="help.howToPlay.whatIsPickX.title" />
                    </div>
                    <p><FormattedMessage id="help.howToPlay.whatIsPickX.content" /></p>
                    <p><FormattedMessage id="help.howToPlay.whatIsPickX.content2" /></p>
                    <button className="makePicksButton" onClick={() => navigate('/lobby/CreateYourOwn')}>
                        <FormattedMessage id="help.howToPlay.whatIsPickX.makeYourPicks" />
                    </button>
                </div>
            </div>
            <HowToPlayContent />
        </div>
    );
};

const HowToPlayContent = () => {
    const [openIndex, setOpenIndex] = useState(null);

    const rules = [
        {
            titleId: "help.howToPlay.howToPlayContent.rule1.title",
            content: (
                <div className="rule1">
                    <p className="t1"><FormattedMessage id="help.howToPlay.howToPlayContent.rule1.content.t1" /></p>
                    <p><FormattedMessage id="help.howToPlay.howToPlayContent.rule1.content.c1" /></p>
                    <p className="t1"><FormattedMessage id="help.howToPlay.howToPlayContent.rule1.content.t2" /></p>
                    <p><FormattedMessage id="help.howToPlay.howToPlayContent.rule1.content.c2" /></p>
                    <p className="t1"><FormattedMessage id="help.howToPlay.howToPlayContent.rule1.content.t3" /></p>
                    <p><FormattedMessage id="help.howToPlay.howToPlayContent.rule1.content.c3" /></p>
                    <p className="t1"><FormattedMessage id="help.howToPlay.howToPlayContent.rule1.content.t4" /></p>
                    <p><FormattedMessage id="help.howToPlay.howToPlayContent.rule1.content.c4" /></p>
                </div>
            )
        },
        {
            titleId: "help.howToPlay.howToPlayContent.rule2.title",
            content: (
                <div className="rule2">
                    <p><FormattedMessage id="help.howToPlay.howToPlayContent.rule2.content" /></p>
                    <PayoutDistributionTable
                        extraTitle="PICK - 12"
                        payoutInfos={new Pick12PayoutCalculator().calculateDistribution(5)}
                        currency={GlobalConst.SITE_CURRENCY}
                        showProgressive
                    />
                </div>
            )
        },
        {
            titleId: "help.howToPlay.howToPlayContent.rule3.title",
            content: (
                <div className="rule3">
                    <p><FormattedMessage id="help.howToPlay.howToPlayContent.rule3.content" /></p>
                    <PayoutDistributionTable
                        extraTitle="PICK - 16"
                        payoutInfos={new Pick16PayoutCalculator().calculateDistribution(5, 45000)}
                        currency={GlobalConst.SITE_CURRENCY}
                        showProgressive
                    />
                </div>
            )
        }
    ];

    const toggleDropDown = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <div className="howToPlaySection">
            <div className="howToPlayContent">
                <div className="mainTitle gold-gradient-text">
                    <FormattedMessage id="help.howToPlay.howToPlayContent.title" />
                </div>
                <div className="howToPlay">
                    <div className="htp-list">
                        {rules.map((rule, index) => (
                            <div key={index} className="htp-item">
                                <div
                                    className={`htp-question ${openIndex === index ? 'opened' : ''}`}
                                    onClick={() => toggleDropDown(index)}
                                >
                                    <FormattedMessage id={rule.titleId} />
                                    <span className="arrow">
                                        <i className={`fa-solid ${openIndex === index ? 'fa-angle-down' : 'fa-angle-right'}`}/>
                                    </span>
                                </div>
                                {openIndex === index && (
                                    <div className="htp-answer">
                                        {rule.content}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HowToPlayView;
